import SendOrDelete from "./SendOrDelete"
import DropdownMenu from "./DropdownMenu"

SendOrDelete.Dropdown = DropdownMenu

export default SendOrDelete
